<!-- SortComponent.vue -->
<template>
    <div class="filters-wrapper">
        <!-- Первая строка - основные фильтры -->
        <div class="sort-line-container">
            <!-- Кнопка сброса фильтров -->
            <div class="reset-filters" @click="resetFilters">Сбросить</div>

            <!-- Фильтр по оплате -->
            <select v-model="localFilters.is_payment" @change="emitFilters">
                <option value="">Оплачено</option>
                <option value="true">Да</option>
                <option value="false">Нет</option>
            </select>

            <!-- Фильтр по службе доставки -->
            <select v-model="localFilters.delivery_service" @change="emitFilters">
                <option value="">Служба доставки</option>
                <option value="СДЭК">СДЭК</option>
                <option value="Почта России">Почта России</option>
                <option value="Avito">Avito</option>
                <option value="Яндекс Доставка">Яндекс Доставка</option>
                <option value="5Post">5Post</option>
            </select>

            <!-- Фильтр по статусу заказа -->
            <select v-model="localFilters.status" @change="emitFilters">
                <option value="">Статус заказа</option>
                <option v-for="st in availableStatuses" :key="st.value" :value="st.value">{{ st.label }}</option>
            </select>
        </div>

        <!-- Календарь с подписями "с" и "по" -->
        <div class="period-selector">
            <div class="date-field">
                <span class="date-label">с</span>
                <input 
                    type="date" 
                    v-model="localFilters.date_from"
                    @change="emitFilters"
                    class="date-input"
                >
            </div>
            <span class="separator">—</span>
            <div class="date-field">
                <span class="date-label">по</span>
                <input 
                    type="date" 
                    v-model="localFilters.date_to"
                    @change="emitFilters"
                    class="date-input"
                    :min="localFilters.date_from"
                >
            </div>
        </div>

        <!-- Переключатель типа -->
        <div class="order-type-switcher">
            <div 
                class="select-order-type" 
                :class="{ 'selected': localFilters.from_abroad === false }"
                @click="selectOrderType"
            >
                Из наличия
            </div>
            <div 
                class="select-order-type" 
                :class="{ 'selected': localFilters.from_abroad === true }"
                @click="selectOrderType"
            >
                Из-за рубежа
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SortComponent',
    data() {
        return {
            localFilters: {
                is_payment: '',
                delivery_service: '',
                status: '',
                date_from: '',
                date_to: '',
                from_abroad: false
            }
        };
    },
    props: {
        admin_sort: {
            type: Boolean,
            default: false,
            required: true,
        },
        filters: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        // Статусы, которые реально выставляет бэкенд. Заграничные этапы — только для заказов из-за рубежа
        availableStatuses() {
            const common = [
                { value: 'waiting_confirmation', label: 'Ожидает подтверждения' },
                { value: 'waiting_shipment', label: 'Ожидает отправки' },
                { value: 'in_transit', label: 'В пути' },
                { value: 'on_return', label: 'Возврат' },
                { value: 'return_closed', label: 'Закрыт после возврата' },
                { value: 'canceled', label: 'Отменен' }
            ];
            const abroad = [
                { value: 'waiting_order', label: 'Ожидает заказа' },
                { value: 'ordered', label: 'Заказан' },
                { value: 'in_china', label: 'Прибыл на распределительный пункт' },
                { value: 'transit_to_rf', label: 'Отправлено в РФ' },
                { value: 'in_rf', label: 'Прибыл в РФ' }
            ];
            const statuses = this.localFilters.from_abroad ? [...abroad, ...common] : common;
            if (this.admin_sort) {
                statuses.push({ value: 'finished', label: 'Завершен' });
            }
            return statuses;
        }
    },
    watch: {
        filters: {
            immediate: true,
            deep: true,
            handler(newFilters) {
                if (newFilters) {
                    this.localFilters = {
                        ...this.localFilters,
                        ...newFilters
                    };
                }
            }
        }
    },
    methods: {
        emitFilters() {
            // Очищаем пустые значения и отправляем фильтры
            const cleanedFilters = Object.fromEntries(
                Object.entries(this.localFilters).filter(([, value]) => {
                    // Оставляем from_abroad даже если false
                    if (value === '' || value === null || value === undefined) {
                        return false;
                    }
                    return true;
                })
            );
            
            this.$emit('filters-change', cleanedFilters);
        },

        resetFilters() {
            // Сбрасываем все фильтры
            this.localFilters = {
                is_payment: '',
                delivery_service: '',
                status: '',
                date_from: '',
                date_to: '',
                from_abroad: false
            };
            this.$emit('filters-change', {});
        },

        selectOrderType() {
            // Переключаем фильтр
            this.localFilters.from_abroad = !this.localFilters.from_abroad;
            // Выбранный статус может не существовать для другого типа заказов
            if (!this.availableStatuses.some(st => st.value === this.localFilters.status)) {
                this.localFilters.status = '';
            }
            this.emitFilters();
        }
    }
};
</script>

<style scoped>
.filters-wrapper {
    width: 100%;
}

.sort-line-container {
    font-family: 'CentureGothic', sans-serif;
    padding: 2vw;
    background-color: rgba(255, 255, 255, 0.08);
    width: 100%;
    display: flex;
    gap: 2vw;
    color: white;
    border-radius: 10px;
    overflow-y: scroll;
    align-items: center;
    margin-bottom: 1vw;
}

.reset-filters {
    padding: 1vw;
    background-color: #090909;
    border-radius: 15px;
    min-width: 25vw;
    max-width: 40vw;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s;
}

.reset-filters:hover {
    background-color: #005ADA;
}

select {
    background-color: #090909;
    color: white;
    font-family: 'CentureGothic', sans-serif;
    border: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffffff'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 2px center;
    border-radius: 15px;
    width: auto;
    padding: 1vw 8vw 1vw 1vw;
    outline: none;
    cursor: pointer;
    transition: background-color 0.3s;
}

select:hover {
    background-color: #005ADA;
}

select:focus {
    outline: none;
    border: none;
    box-shadow: none;
}

select:active,
select:visited,
select:focus-visible {
    outline: none;
    border: none;
    box-shadow: none;
}

select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #ffffff;
}

select::-ms-expand {
    display: none;
}

/* Календарь с подписями "с" и "по" */
.period-selector {
    display: flex;
    align-items: center;
    gap: 1vw;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 1vw;
    margin-bottom: 1vw;
}

.date-field {
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: #090909;
    border-radius: 10px;
    padding: 1vw;
    flex: 1;
}

.date-label {
    color: #aaa;
    font-size: 14px;
    font-weight: 500;
    min-width: 20px;
    text-align: left;
}

.date-input {
    background-color: transparent;
    color: white;
    font-family: 'CentureGothic', sans-serif;
    border: none;
    border-radius: 8px;
    padding: 0.5vw;
    outline: none;
    cursor: pointer;
    width: 130px;
}

.date-input:hover {
    background-color: #005ADA;
}

.date-input::-webkit-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
    opacity: 0.8;
}

.date-input::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
}

.separator {
    color: #888;
    font-size: 16px;
}

/* Переключатель типа заказа */
.order-type-switcher {
    background-color: rgba(255, 255, 255, 0.08);
    padding: 1vw;
    border-radius: 10px;
    display: flex;
    gap: 1vw;
}

.select-order-type {
    flex: 1;
    padding: 1vw 2vw;
    background-color: #090909;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    color: white;
    text-align: center;
}

.select-order-type:hover {
    background-color: #005ADA;
}

.selected {
    background-color: #005ADA;
}
</style>